import {Dialog as DialogPrimitive} from '@base-ui/react/dialog'
import {useTranslation} from '@/translations/i18n.tsx'
import {MessageSmileSquareIcon, XCloseIcon} from '@components/ui/icon'
import {AiChatBody} from '@features/ai-chatbot/components/ai-chat-body'
import {CHAT_LAUNCHER_CLASSNAME} from '@features/ai-chatbot/constants.ts'
import {useChatStore} from '@features/ai-chatbot/store/store.ts'
import {useMediaQuery} from '@/hooks/use-media-query'
import {cn} from '@utilities/helpers'

/**
 * Mobile AI assistant: the same body as the desktop popover, promoted to a
 * fullscreen dialog so the keyboard doesn't fight a floating panel.
 */
export const AiChatDialog = () => {
    const {t} = useTranslation()
    const isDesktop = useMediaQuery({breakpoint: 'md'})
    const isOpen = useChatStore(state => state.isOpen)
    const setIsOpen = useChatStore(state => state.setIsOpen)
    const toggleOpen = useChatStore(state => state.toggleOpen)

    if (isDesktop) {
        return null
    }

    return (
        <>
            <button
                aria-label={t('ai_chatbot:header')}
                className={cn(CHAT_LAUNCHER_CLASSNAME, 'md:hidden')}
                onClick={toggleOpen}
                type="button"
            >
                {isOpen ? <XCloseIcon className="size-5" /> : <MessageSmileSquareIcon className="size-5" />}
            </button>

            <DialogPrimitive.Root onOpenChange={setIsOpen} open={isOpen}>
                <DialogPrimitive.Portal>
                    <DialogPrimitive.Backdrop className="fixed inset-0 z-modal-overlay bg-grey-1000/40 data-closed:animate-airbnb-backdrop-close data-open:animate-airbnb-backdrop-open" />
                    <DialogPrimitive.Popup
                        className="fixed inset-0 z-modal flex flex-col bg-white data-closed:animate-airbnb-modal-close data-open:animate-airbnb-modal-open"
                        data-slot="ai-chat-dialog"
                    >
                        <DialogPrimitive.Title className="sr-only">{t('ai_chatbot:header')}</DialogPrimitive.Title>
                        <AiChatBody onClose={() => setIsOpen(false)} />
                    </DialogPrimitive.Popup>
                </DialogPrimitive.Portal>
            </DialogPrimitive.Root>
        </>
    )
}

AiChatDialog.displayName = 'AiChatDialog'
